var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdf-icon",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pdf-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.009256 0.018048 21.05056 0.018048 21.05056 25.999968 0.009256 25.999968"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.009264 0.018 20.5705717 0.018 20.5705717 25.519984 0.009264 25.519984"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0.01584 13.227416 0.01584 13.227416 6.87688 0 6.87688"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-download-pdf",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-download-pdf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped",
    transform: "translate(4.320000, 0.142000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.040696,9.186368 C21.033656,9.120928 21.019336,9.056368 20.998216,8.995008 L20.995816,8.988048 C20.988296,8.965008 20.980376,8.942608 20.965896,8.909648 C20.917416,8.804368 20.858776,8.718608 20.787816,8.648768 L12.420536,0.281008 C12.348616,0.209088 12.263496,0.150928 12.161176,0.103568 C12.135016,0.091408 12.108616,0.081728 12.083576,0.073728 L12.075656,0.071088 C12.012616,0.049568 11.949416,0.035408 11.882696,0.028048 C11.850456,0.021408 11.817976,0.018048 11.785736,0.018048 L0.907336,0.018048 C0.412216,0.018048 0.009256,0.420928 0.009256,0.916128 L0.009256,25.101968 C0.009256,25.597088 0.412216,25.999968 0.907336,25.999968 L20.152376,25.999968 C20.647656,25.999968 21.05062,25.597088 21.05062,25.101968 L21.05062,9.289728 C21.051016,9.255328 21.047736,9.220688 21.040696,9.186368",
    id: "Fill-1",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.929288,12.49888 L3.929288,24.92392 C3.929288,25.2868 4.224488,25.582 4.587368,25.582 L23.832408,25.582 C24.195288,25.582 24.4906199,25.2868 24.4906199,24.92392 L24.4906199,9.10808 C24.490968,9.0824 24.486968,9.06112 24.483288,9.04632 C24.478728,8.99432 24.467768,8.94312 24.450968,8.89408 L24.447768,8.88488 C24.442408,8.8684 24.436888,8.8524 24.428008,8.83224 C24.391768,8.75368 24.348968,8.69056 24.298088,8.64048 L15.930968,0.27272 C15.879288,0.22112 15.816568,0.17864 15.739848,0.1432 C15.722808,0.13528 15.705528,0.12912 15.687928,0.12352 L15.677928,0.12016 C15.628248,0.1032 15.578328,0.0924 15.524088,0.08736 C15.510488,0.084 15.490168,0.08 15.465768,0.08 L4.587368,0.08 C4.224488,0.08 3.929288,0.37528 3.929288,0.73808 L3.929288,4.43784 L3.929288,12.49888 Z",
    id: "Fill-4",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.490736,22.314968 C14.806576,22.619528 15.184976,22.462968 15.313056,22.314968 L18.847216,18.783688 C19.074816,18.556168 19.074816,18.189048 18.847216,17.961368 C18.619536,17.733688 18.252496,17.733688 18.024816,17.961368 L15.480896,20.502408 L15.480896,13.923368 C15.480896,13.601768 15.222016,13.342888 14.900496,13.342888 C14.578896,13.342888 14.320016,13.601768 14.320016,13.923368 L14.320016,20.499608 L11.776096,17.958568 C11.548496,17.730888 11.181376,17.730888 10.953776,17.958568 C10.726096,18.186248 10.726096,18.553288 10.953776,18.780888 L14.490736,22.314968 Z",
    id: "Fill-6",
    fill: "#3A3A3A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-8-Clipped",
    transform: "translate(3.920000, 0.062000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.203744,8.385664 L12.203744,2.264624 L18.324384,8.385664 L12.203744,8.385664 Z M20.563264,8.984304 C20.558784,8.932304 20.547824,8.881104 20.530944,8.832064 L20.527824,8.822864 C20.522384,8.806384 20.516864,8.790464 20.508064,8.770224 C20.471824,8.691664 20.428944,8.628624 20.378144,8.578464 L12.010944,0.210704 C11.959264,0.159104 11.896544,0.116624 11.819824,0.081184 C11.802784,0.073264 11.785504,0.067184 11.767984,0.061504 L11.757984,0.058144 C11.708304,0.041184 11.658384,0.030464 11.604064,0.025424 C11.590464,0.021984 11.570144,0.017984 11.545744,0.017984 L0.667344,0.017984 C0.304464,0.017984 0.009264,0.313264 0.009264,0.676064 L0.009264,4.375824 L1.325424,4.375824 L1.325424,1.334064 L10.887184,1.334064 L10.887184,9.043744 C10.887184,9.406544 11.182384,9.701744 11.545344,9.701744 L19.254464,9.701744 L19.254464,24.203824 L1.325424,24.203824 L1.325424,12.436864 L0.009264,12.436864 L0.009264,24.861984 C0.009264,25.224784 0.304464,25.519984 0.667344,25.519984 L19.912384,25.519984 C20.275344,25.519984 20.5705959,25.224784 20.5705959,24.861984 L20.5705959,9.046064 C20.570944,9.020384 20.566944,8.999104 20.563264,8.984304 L20.563264,8.984304 Z",
    id: "Fill-8",
    fill: "#3A3A3A",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    points: "16.123744 8.447664 16.123744 2.326624 22.244384 8.447664"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-13-Clipped",
    transform: "translate(0.000000, 5.022000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.777336,6.87688 L0.450136,6.87688 C0.202536,6.87688 -2.4e-05,6.67432 -2.4e-05,6.4268 L-2.4e-05,0.46592 C-2.4e-05,0.2184 0.202536,0.01584 0.450136,0.01584 L12.777336,0.01584 C13.024936,0.01584 13.227416,0.2184 13.227416,0.46592 L13.227416,6.4268 C13.227416,6.67432 13.024936,6.87688 12.777336,6.87688",
    id: "Fill-13",
    fill: "#FF5D43",
    fillRule: "nonzero",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.846752,8.359152 C3.450112,8.359152 3.739472,8.116432 3.739472,7.618352 C3.739472,7.116432 3.437072,6.944352 2.846752,6.944352 L2.291792,6.944352 L2.291792,8.359152 L2.846752,8.359152 Z M1.569072,6.366752 L2.904272,6.366752 C3.793872,6.366752 4.452992,6.678032 4.452992,7.618352 C4.452992,8.527712 3.780832,8.936752 2.904272,8.936752 L2.291792,8.936752 L2.291792,10.429152 L1.569072,10.429152 L1.569072,6.366752 Z",
    id: "Fill-16",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.257336,9.843016 C7.032616,9.843016 7.476536,9.378776 7.476536,8.379256 C7.476536,7.383736 7.032616,6.952856 6.257336,6.952856 L5.960536,6.952856 L5.960536,9.843016 L6.257336,9.843016 Z M5.237816,6.366696 L6.301416,6.366696 C7.500456,6.366696 8.220056,7.036696 8.220056,8.379256 C8.220056,9.725816 7.500456,10.429176 6.340056,10.429176 L5.237816,10.429176 L5.237816,6.366696 Z",
    id: "Fill-18",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "9.214912 6.366728 11.814832 6.366728 11.814832 6.974408 9.937552 6.974408 9.937552 8.126328 11.533152 8.126328 11.533152 8.734008 9.937552 8.734008 9.937552 10.429128 9.214912 10.429128"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.3744b7c0.svg";
export { ForwardRef as ReactComponent };